import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, Injectable, OnInit, ViewChild } from '@angular/core';
import { ChildrenOutletContexts, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CacheService } from 'src/app/shared/services/Cache/cache.service';
import { Company, ConnectionService} from 'src/app/shared/services/Connection/connection.service';
import { DOCUMENT } from '@angular/common';
import { trigger, transition, style, query, animate, group } from '@angular/animations';
import { Subscription, filter } from 'rxjs';
import { he } from 'date-fns/locale';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
  animations: [
    trigger('routeAnimations', [
      transition('* <=> *', [
        style({ position: 'relative' }),
        query(':enter, :leave', [
          style({
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
          })
        ], { optional: true }),

        group([
        // Anima a tela que está saindo
        query(':leave', [
          animate('280ms ease', style({ transform: 'translateX(-8%)', opacity: 0 }))
        ], { optional: true }),

        // Anima a nova tela com pequeno atraso para sobreposição suave
        query(':enter', [
          style({ transform: 'translateX(12%)', opacity: 0 }),
          animate('320ms 60ms ease', style({ transform: 'translateX(0)', opacity: 1 }))
        ], { optional: true })
        ])
      ])
    ])
  ]

})
@Injectable({
  providedIn: 'root'
})
export class LayoutComponent implements OnInit, AfterViewInit {
routeAnimations: string | null = null;
//#region Variaveis de elemento HTML
  @ViewChild('mainContainer') mainContainer!: ElementRef;
//#endregion

//#region Variaveis Locais
  gif = false;
  stopLoading = false;
  private routerSubscription: Subscription | undefined;
  nameCompany: string = '';
  bottomMenu: boolean = true;
  company!: Company;
//#endregion

//#region Inicializadores
constructor(
  private router: Router,
  private connection: ConnectionService,
  private cacheService: CacheService,
  @Inject(DOCUMENT) private document: Document,
  private cdr: ChangeDetectorRef
)
{
  this.connection.StopLoading$.subscribe((newValue) =>{
    this.stopLoading = newValue
  })

  this.connection.nameCompany$.subscribe((nameCompany) =>{
    this.nameCompany = nameCompany;
  })
  
  this.connection.company$.subscribe((data) =>{
    if(data){
      this.company = data;
    }
  })
}

ngOnInit(): void {
  this.cacheService.setItemLocal('dark-theme', false);

  this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      const route = event.urlAfterRedirects
      this.checkScreenSize()
      
      if(route.includes('product-detail') || route.includes('order-confirmation')
        || route.includes('user-data') || route.includes('address')
        || route.includes('order-details') || route.includes('coupons')
        || route.includes('fidelity') || route.includes('processing') || route.includes('history-cashback') ){
        this.bottomMenu = false;
      }
      else{
        this.bottomMenu = true;
      }
    }
  });
}

ngAfterViewInit(): void {
  this.checkScreenSize();

  if(this.cacheService.getItemLocal('dark-theme')){
    this.addClassDark();
  }

  if(this.router.url.includes('pedidos') || this.router.url.includes('order-details')){
    this.connection.updateStopLoading(true);
    this.cdr.detectChanges();
  }

  if(this.router.url.includes('product-detail') || this.router.url.includes('order-details')){
    this.bottomMenu = false;
  }

  this.routeAnimations = 'MenuPage';
  this.cdr.detectChanges();

}

//#endregion

//#region Funções de estilo (Style)

  prepareRoute(outlet: RouterOutlet | null) {
    return outlet?.activatedRouteData?.['animation'] || null;
  }

  //Adiciona a classe theme-dark ao body
  addclass() {
    const body = this.document.body;
    body.classList.toggle('theme-dark');
  }

  addClassDark(){
    const body = this.document.body;
    body.classList.add('theme-dark');
  }

  //captura a alteração no size da tela
  @HostListener('window:resize', [])
  onWindowResize(event: any) {
    this.checkScreenSize();
  }

  //Captura o size da tela e adiciona ou remove class dos elementos de acordo com o tamanhoda tela
  checkScreenSize(){
    if(window.innerWidth <= 1168)
    {
      if(this.mainContainer)
      {
        //main
        this.mainContainer.nativeElement.classList.add('responsive')
        this.mainContainer.nativeElement.classList.remove('large')
      }
    }
    else{

      //main
      if
      (
        this.router.url.includes('user-data') || this.router.url.includes('feedback')
        || this.router.url.includes('carrinho') || this.router.url.includes('consumption')
        || this.router.url.includes('pedidos') || this.router.url.includes('order-confirmation')
        || this.router.url.includes('order-details') || this.router.url.includes('edit-product')
        || this.router.url.includes('address') || this.router.url.includes('user')
        || this.router.url.includes('coupons') || this.router.url.includes('fidelity')
        || this.router.url.includes('history-cashback')
      )
      {
        this.mainContainer.nativeElement.classList.add('responsive')
        this.mainContainer.nativeElement.classList.remove('large')
      }
      else{
        if(this.mainContainer){
          this.mainContainer.nativeElement.classList.remove('responsive')
        }
      }

    }
  }

  //#endregion
}
